import React from 'react';
import { MapPin, Mail, Phone } from 'lucide-react';
import { Logo } from './ui/Logo';
import { useLanguage } from '../context/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-navy-dark text-white/70 py-12 border-t border-white/10" data-id="element-177">
      <div className="container mx-auto px-6 md:px-12" data-id="element-178">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-179">
          <div className="col-span-1 md:col-span-2" data-id="element-180">
            <Logo variant="light" className="mb-6" data-id="element-181" />
            <p className="max-w-sm mb-6" data-id="element-182">{t.footer.desc}</p>
            <ul className="space-y-3 text-sm" data-id="element-183">
              <li className="flex items-start gap-3" data-id="element-184">
                <MapPin className="w-5 h-5 text-sand flex-shrink-0 mt-0.5" data-id="element-185" />
                <span data-id="element-186">
                  C/ Cuescaro, 14, 38639, Las Chafiras, Santa Cruz de Tenerife
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-187">
                <Mail className="w-5 h-5 text-sand flex-shrink-0" data-id="element-188" />
                <a href="mailto:info@homefort.es" className="hover:text-white transition-colors" data-id="element-189">
                  info@homefort.es
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-190">
                <Phone className="w-5 h-5 text-sand flex-shrink-0" data-id="element-191" />
                <a href="tel:+34689621262" className="hover:text-white transition-colors" data-id="element-192">
                  (+34) 689 621 262
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-193">
            <h4 className="text-white font-medium mb-4" data-id="element-194">{t.footer.links}</h4>
            <ul className="space-y-2" data-id="element-195">
              <li data-id="element-196">
                <a href="#entorno" className="hover:text-white transition-colors" data-id="element-197">
                  {t.nav.entorno}
                </a>
              </li>
              <li data-id="element-198">
                <a href="#calidades" className="hover:text-white transition-colors" data-id="element-199">
                  {t.nav.calidades}
                </a>
              </li>
              <li data-id="element-200">
                <a href="#disponibilidad" className="hover:text-white transition-colors" data-id="element-201">
                  {t.nav.disponibilidad}
                </a>
              </li>
              <li data-id="element-202">
                <a href="#contacto" className="hover:text-white transition-colors" data-id="element-203">
                  {t.nav.contacto}
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-204">
            <h4 className="text-white font-medium mb-4" data-id="element-205">{t.footer.legal}</h4>
            <ul className="space-y-2" data-id="element-206">
              <li data-id="element-207">
                <a href="#" className="hover:text-white transition-colors" data-id="element-208">
                  {t.footer.legalLinks.notice}
                </a>
              </li>
              <li data-id="element-209">
                <a href="#" className="hover:text-white transition-colors" data-id="element-210">
                  {t.footer.legalLinks.privacy}
                </a>
              </li>
              <li data-id="element-211">
                <a href="#" className="hover:text-white transition-colors" data-id="element-212">
                  {t.footer.legalLinks.cookies}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm" data-id="element-213">
          <p data-id="element-214">
            &copy; {new Date().getFullYear()} {t.footer.rights}
          </p>
          <p data-id="element-215">{t.footer.disclaimer}</p>
        </div>
      </div>
    </footer>;
}